module.exports = __webpack_public_path__ + "static/img/dxuan.eecdad9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourse/dxuan.png
// module id = WyNO
// module chunks = 96